export default __webpack_public_path__ + "static/media/exzoswap-logo.5d77e73c.png";